import { InjectionToken } from '@angular/core';

export const COUNTRIES = new InjectionToken<{[k: string]: any}>('app.countries');